export enum SessionStage {
    PLAN = 'PLAN',
    CREATE = 'CREATE',
    PUBLISH = 'PUBLISH',
}

export interface ISession {
    name: string;
    sessionKey: string;
    new: boolean;
    stage: SessionStage | SessionStage.PLAN;
}

export interface IGetActiveSessionResponse {
    currentlyWorkingSession: ISession | null;
    sessions: ISession[];
}
